import styled from '@emotion/styled';
import React from 'react';
import { useParams } from 'react-router-dom';

import UserNavigationMenu from '../settings/user-navigation-menu';

import { useDashboardDataContext } from '~/client/components/project/dashboard/dashboard-context';
import { LeftNavMenu } from '~c/components/base/left-nav';
import { projectReportRouteUtil, useDashboardHandlers } from '~c/routes';

interface Props {
  className?: string;
}

const ExecutiveReportLeftNavImpl: React.FC<Props> = ({ className }) => {
  const { candidateId, functionalModelId } = useParams();

  const { navigateToMainDashboard } = useDashboardHandlers();
  const { project } = useDashboardDataContext();

  return (
    <LeftNavMenu
      className={className}
      name={projectReportRouteUtil.routePrefix}
      header={{
        onClick: () =>
          navigateToMainDashboard(
            candidateId,
            functionalModelId,
            undefined,
            undefined,
            undefined,
            project?.projectType
          ),
      }}
    >
      <UserNavigationMenu />
    </LeftNavMenu>
  );
};

const ExecutiveReportLeftNav = styled(ExecutiveReportLeftNavImpl)`
  .grow {
    flex-grow: 1;
  }
`;

export default ExecutiveReportLeftNav;
